
import { useEffect, useState } from "react";
import { QuixVideo } from "./QuixVideo";
import { useInView } from "react-intersection-observer";

interface QuixFeedProps {
  videos: Array<{
    id: string;
    url: string;
    description: string;
    profiles: {
      username: string;
      avatar_url: string | null;
    };
    likes_count: number;
    comments_count: number;
    shares_count: number;
    bookmarks_count: number;
  }>;
  onLoadMore: () => void;
  isLoading?: boolean;
}

export const QuixFeed = ({ videos, onLoadMore, isLoading = false }: QuixFeedProps) => {
  const [initialLoading, setInitialLoading] = useState(true);
  const { ref, inView } = useInView({
    threshold: 0.5,
    rootMargin: '100px',
  });

  useEffect(() => {
    if (videos.length > 0) {
      setInitialLoading(false);
    }
  }, [videos]);

  useEffect(() => {
    if (inView && !isLoading && !initialLoading) {
      onLoadMore();
    }
  }, [inView, onLoadMore, isLoading, initialLoading]);

  if (initialLoading) {
    return (
      <div className="h-screen flex items-center justify-center bg-black">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-flux-cyan border-t-transparent" />
      </div>
    );
  }

  if (!videos.length) {
    return (
      <div className="h-screen flex items-center justify-center bg-black">
        <p className="text-white text-center">No videos available</p>
      </div>
    );
  }

  console.log("Rendering videos:", videos);

  return (
    <div className="h-[calc(100vh-56px)] w-full overflow-y-scroll snap-y snap-mandatory pb-14">
      {videos.map((video, index) => (
        <div 
          key={`${video.id}-${index}`} 
          ref={index === videos.length - 1 ? ref : undefined}
          className="h-[calc(100vh-56px)]"
        >
          <QuixVideo video={video} autoPlay={index === 0} />
        </div>
      ))}
      {isLoading && videos.length > 0 && (
        <div className="flex justify-center items-center py-4">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-flux-cyan border-t-transparent" />
        </div>
      )}
    </div>
  );
};
